import { parse } from 'query-string';
import { onSaleParam, sortOptionPVInsertTime } from './helpers';

const api = {
  newsletterSignup: '/api/newsletter'
};

const canonicalBaseUrl = 'https://www.italist.com';
const reviews = '/reviews';
const aboutUs = '/about_us';
const cart = '/cart';
const charitableGiving = '/charitable_giving';
const contactUs = '/contact_us';
const ipForm = '/contact_us/ip_form/';
const press = '/press';
const privacy = '/privacy';
const customerService = '/customer_service';
const howToShop = '/customer_service/#how_to_shop';
const ordersAndShipping = '/customer_service/#orders_and_shipping';
const serviceUpdates = '/customer_service/#service_updates';
const returnsAndRefunds = '/customer_service/#returns_and_refunds';
const returnsPolicy = '/customer_service/#returns_policy';
const promotionsPolicy = '/customer_service/#promotions_policy';
const faq = '/customer_service/#faq';
const recoverPassword = '/recover_password';
const termsAndCondition = '/terms';
const home = '/';
const signup = '/signup';
const magazine = 'https://www.italist.com/magazine/';
const brandsUrl = '/brands';
const womenSearchUrl = '/women/1/?q=';

const linkedIn = 'https://www.linkedin.com/company/italist-com/';
const angeListJobs = 'https://angel.co/italist/jobs';

const womenUrl = '/women/1';
const menUrl = '/men/124';
const kidsUrl = '/kids';

const menUrlNewInSale = (sale = false) => `/men/?${sale ? onSaleParam : `sort_field=${sortOptionPVInsertTime}`}`;
const womenUrlNewInSale = (sale = false) => `/women/?${sale ? onSaleParam : `sort_field=${sortOptionPVInsertTime}`}`;
const kidsUrlNewInSale = (sale = false) => `/kids/?${sale ? onSaleParam : `sort_field=${sortOptionPVInsertTime}`}`;

const search = (department, query) => `/${department}/?q=${encodeURIComponent(query)}`;

const buildBrandUrlWithCategory = (brandUrl, brand_id, categoryId) =>
  `${brandUrl}/?categories%5B%5D=${categoryId}&brands%5B%5D=${brand_id}&page=BrandDetail&sort_field=insert_time&q=&limit=60&skip=0`;

const buildBreadCrumbUrl = url => url.replace(/^\/?(en)?\/?/, '/');

const getRedirectPath = ownProps => {
  const { redirect } = parse(window.location.search);
  return redirect === 'checkout' ? ownProps.basePathSecure : redirect;
};

export {
  api,
  aboutUs,
  brandsUrl,
  angeListJobs,
  buildBreadCrumbUrl,
  buildBrandUrlWithCategory,
  cart,
  canonicalBaseUrl,
  charitableGiving,
  contactUs,
  customerService,
  ipForm,
  howToShop,
  faq,
  getRedirectPath,
  womenSearchUrl,
  home,
  linkedIn,
  magazine,
  ordersAndShipping,
  serviceUpdates,
  press,
  privacy,
  promotionsPolicy,
  returnsAndRefunds,
  returnsPolicy,
  reviews,
  search,
  recoverPassword,
  termsAndCondition,
  signup,
  menUrlNewInSale,
  womenUrlNewInSale,
  kidsUrlNewInSale,
  womenUrl,
  menUrl,
  kidsUrl
};
